<div class="form-wrapper overflow-auto mb-2">
  <div class="my-3 row" [formGroup]="dynamicForm">
    @for (field of formFields; track field; let i = $index) {
      @if (field.required) {
        <div class="col-lg-6 col-md-12 col-sm-12 g-3 w-50">
          <div class="col-lg-6 col-md-12 col-sm-12 flex-wrapper gap-3 d-flex align-items-center mb-1 mx-2">
            <div class="label-required">
              <div class="label-container d-flex align-items-start">
                <div class="label-wrapper d-inline-block">
                  <label class="field-label fw-semibold" for="{{ field?.name }}">
                    <span class="label-text text-break d-inline">{{ 'FIELDS.' + field.label | translate }}</span>
                    @if (field.required) {
                      <span class="asterisk-field ms-1 d-inline text-danger">*</span>
                    }
                  </label>
                </div>
              </div>
            </div>
            <div class="all-input col-md-6 w-25">
              @switch (field?.type) {
                @case ('number') {
                  <input
                    class="form-control fw-normal w-100"
                    type="number"
                    step="0.1"
                    [formControlName]="field?.name"
                    [required]="field?.required"
                    (blur)="onInputChange($event, field)"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1" />
                }
                @case ('text') {
                  <input
                    type="text"
                    class="form-control w-100"
                    [formControlName]="field?.name"
                    [required]="field?.required"
                    (blur)="onInputChange($event, field)"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1" />
                }
                @case ('dropdown') {
                  <select
                    class="drop-down-input form-control form-select fw-normal w-100"
                    [formControlName]="field?.name"
                    [required]="field?.required"
                    [id]="field?.name"
                    [attr.tabindex]="i + 1">
                    @for (option of field?.options; track option) {
                      <option [value]="option">{{ option }}</option>
                    }
                  </select>
                }
              }
            </div>
            @if (field.units) {
              <div class="all-units col-md-6 w-50">
                <select
                  class="dropDown form-control form-select text-center fw-normal w-75"
                  (change)="onUnitChange($event, field)"
                  [id]="field?.name + '_units'"
                  [attr.tabindex]="100 + i">
                  @for (unit of field.units; track unit) {
                    <option [value]="unit" [selected]="unit === selectedUnits[field.name]">{{ unit }}</option>
                  }
                </select>
              </div>
            }
            @if (!field.units) {
              <div class="col-md-6">
                <div>{{ field.unitValue }}</div>
              </div>
            }
          </div>
          @if (
            dynamicForm.controls[field.name].invalid && (dynamicForm.controls[field.name].dirty || dynamicForm.controls[field.name].touched)
          ) {
            <div class="mb-3 px-2 error-message">
              @if (dynamicForm.controls[field.name].errors?.['required']) {
                <span class="w-100 text-danger required-error-msg fw-normal">
                  {{ 'FIELDS.' + field.label | translate }} {{ 'REQUIRED' | translate }}
                </span>
              }
              @if (dynamicForm.controls[field.name].errors?.['min']) {
                <span class="w-100 text-danger fw-normal">
                  {{
                    'FIELDS.BELOW_MINIMUM'
                      | translate
                        : { min: dynamicForm.controls[field.name].errors['min'].min, unit: selectedUnits[field.name] ?? field.unitValue }
                  }}
                </span>
              }
              @if (dynamicForm.controls[field.name].errors?.['max']) {
                <span class="w-100 text-danger fw-normal">
                  {{
                    'FIELDS.ABOVE_MAXIMUM'
                      | translate
                        : { max: dynamicForm.controls[field.name].errors['max'].max, unit: selectedUnits[field.name] ?? field.unitValue }
                  }}
                </span>
              }
            </div>
          }
          @if (field.name === FormInputs.INLET_TEMPERATURE && showWarning) {
            <div class="text-danger px-2 w-100">
              {{ 'WARNINGS.HIGH_AMBIENT_TEMPERATURE' | translate }}
            </div>
          }
        </div>
      }
    }
  </div>
</div>
